// extracted by mini-css-extract-plugin
export var text = "_b4-0";